import React from 'react';
import './AutoAppointmentComplete.scss';

const AutoAppointmentComplete = ({ onFsListItem, type = [] }) => {
  console.log('onFsListItem', onFsListItem, type);
  return (
    <div className='ne_dropdown_menu'>
      <ul className='ne_dropdown_list px-3'>
        {type.map((appointment, idx) => (
          <li
            key={idx}
            className='ne-scope p-2'
            onClick={() => onFsListItem(appointment)}
          >
            <a className='ne_dropdown_item'>
              <span className='ne-binding'>
                {appointment.appointmentDate.split('T')[0]} -{' '}
                {appointment.serviceName}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AutoAppointmentComplete;
